import { inferenceHttp } from '@/lib/api/inference-client';
import {
  CreateMcpCatalogDto,
  McpCatalogResponseDto,
  McpCatalogService,
  UpdateMcpCatalogDto,
} from '@inference.engine/api-client/web';

export const getMcpCatalog = async (): Promise<McpCatalogResponseDto[]> => {
  const response = await McpCatalogService.list({ client: inferenceHttp });

  return response.data ?? [];
};

export const createMcpCatalog = async (
  body: CreateMcpCatalogDto,
): Promise<McpCatalogResponseDto> => {
  const response = await McpCatalogService.create({ client: inferenceHttp, body });

  return response.data!;
};

export const updateMcpCatalog = async (
  body: UpdateMcpCatalogDto,
  id: string,
): Promise<McpCatalogResponseDto> => {
  const response = await McpCatalogService.update({ client: inferenceHttp, body, path: { id } });

  return response.data!;
};

export const deleteMcpCatalog = async (id: string): Promise<void> => {
  await McpCatalogService.remove({ client: inferenceHttp, path: { id } });
};
